module.exports = __webpack_public_path__ + "static/media/academic-details.ed45ec31.svg";